import EventEmitter from 'events'
import { toChecksumAddress } from 'web3-utils'

const ethereum = (typeof window !== 'undefined') && window.ethereum

export const eventEmitter = new EventEmitter()

if (ethereum) {
  ethereum.autoRefreshOnNetworkChange = false

  ethereum.on('accountsChanged', async (accounts) => {
    if (accounts && Array.isArray(accounts) && accounts.length > 0) {
      eventEmitter.emit(
        'accountsChanged',
        accounts.map((item) => toChecksumAddress(item))
      )
    }
    if (accounts && Array.isArray(accounts) && accounts.length === 0) {
      eventEmitter.emit('disconnect')
    }
  })

  ethereum.on('chainChanged', (chainId) => {
    if (chainId) {
      eventEmitter.emit('chainChanged', parseInt(chainId, 16))
    }
  })

  ethereum.on('connect', () => {
    eventEmitter.emit('connect')
  })

  ethereum.on('disconnect', () => {
    eventEmitter.emit('disconnect')
  })
}

export function getProvider () {
  return ethereum
}

export function isMetamaskInstalled () {
  return !!ethereum
}

export async function getAddress () {
  if (isMetamaskInstalled()) {
    const accounts = await ethereum.request({ method: 'eth_requestAccounts' })
    return toChecksumAddress(accounts[0])
  }
  return null
}

export async function getChainId () {
  if (isMetamaskInstalled()) {
    const chainId = await ethereum.request({ method: 'net_version' })
    return Number(chainId)
  }
  return null
}
